import { render, staticRenderFns } from "./configuration-assays-modal-basic-form.vue?vue&type=template&id=68d7f89d&scoped=true&"
import script from "./configuration-assays-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-assays-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-assays-modal-basic-form.scss?vue&type=style&index=0&id=68d7f89d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7f89d",
  null
  
)

export default component.exports